import {
	Autocomplete,
	Box,
	Breadcrumbs,
	Button,
	Container,
	Divider,
	Grid,
	IconButton,
	Link,
	MenuItem,
	TextField,
	Typography,
	Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
	useTheme,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Form, Formik, getIn } from "formik";
import * as Yup from "yup";
import CompulsoryFieldsLabel from "../../helpers/CompulsoryFields";
import queryGraphql from "../../helpers/ApiInterface";
import { useAuth } from "../../helpers/AuthProvider";
import MiniBot from "../MiniBot";
import MainDrawer, { openDrawerWidth, collapsedDrawerWidth } from "../MainDrawer"; // Adjust path if needed

interface ServiceFormProps {
	isEdit: boolean;
}
interface ServiceFormContentProps {
	isEdit: boolean;
}
const validationSchema = Yup.object().shape({
	serviceName: Yup.string()
		.required("This field is required")
		.strict()
		.lowercase("This field must be in lowercase")
		.matches(/^[a-zA-Z0-9-\s]*$/, "This field must be alphanumeric")
		.max(20, "This field must not exceed 20 characters"),

	gcpServiceViewers: Yup.array()
		.of(
			Yup.string()
				.required("This field is required")
				.matches(/^[a-zA-Z0-9._%+-]+@searce\.com$/, "Invalid domain")
				.strict()
		)
		.required("This field is required")
		.min(1, "This field is required")
		.strict(),
	cluster: Yup.string().required("This field is required").strict(),
	application: Yup.string().required("This field is required").strict(),

	serviceRequesters: Yup.array()
		.of(
			Yup.string()
				.required("This field is required")
				.matches(/^[a-zA-Z0-9._%+-]+@searce\.com$/, "Invalid domain")
				.strict()
		)
		.required("This field is required")
		.min(1, "This field is required")
		.strict(),

	framework: Yup.string().required("This field is required"),
	costCenterValue: Yup.string()
			.required("This field is required")
			.strict()
			.lowercase("This field must be in lowercase")
			.matches(/^[a-zA-Z0-9-\s]*$/, "This field must be alphanumeric")
			.max(20, "This field must not exceed 20 characters"),

	costLabelPairs: Yup.array()
			.of(
				Yup.object({
					cost: Yup.string()
						.required("This field is required")
						.strict()
						.lowercase("This field must be in lowercase")
						.matches(/^[a-zA-Z0-9-\s]*$/, "This field must be alphanumeric")
						.max(20, "This field must not exceed 20 characters"),
					label: Yup.string()
						.required("This field is required")
						.strict()
						.lowercase("This field must be in lowercase")
						.matches(/^[a-zA-Z0-9-\s]*$/, "This field must be alphanumeric")
						.max(20, "This field must not exceed 20 characters"),
				})
			)
});
const frameworkList: Array<string> = ["Node.js", "Go", "Java", "Python", "Ruby"];

const ServiceRequesterFormContent: React.FC<ServiceFormContentProps> = ({ isEdit }) => {
	const navigate = useNavigate();
	const { id } = useParams();
	const [users, setUsers] = useState([]);
	const [service, setService] = useState<any>({});
	const [applications, setApplications] = useState<any>([]);
	const [clustersNamesList, setClustersNamesList] = useState<any>([]);
	const [applicationsNamesList, setApplicationsNamesList] = useState<any>([]);
	const [currentCluster, setCurrentCluster] = useState<any>([]);
	const [currentApplication,setCurrentApplication] = useState<any>([]);
	const [currentService, setCurrentService] = useState<any>();
	const [allServices, setAllServices]= useState<any>([]);
	const [nameChange, setNameChange] = useState<boolean>(false)
	const [CurrentApplicationId,setCurrentApplicationId] = useState<any>([]);
	const [rerender, setRerender] = useState<any>();
	const [filteredServices, setFilteredServices] = useState<any>([]);
	const { user } = useAuth();
	const isViewer = user.roles?.some((role: string) => role === "viewer") || false;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const handleOpenModal = () => setIsModalOpen(true);
	const handleCloseModal = () => setIsModalOpen(false);
	React.useEffect(() => {
		const intervalId = setInterval(() => {
		  setRerender(new Date().toLocaleTimeString());
		}, 2000);
	
		return () => {
		  clearInterval(intervalId);
		};
	  }, []);
	React.useEffect(() => {
			(async () => {
				try {
					const data = await queryGraphql(`
							query Services {
  								services {
    								id
    							serviceName
								status
								framework
								application {
								applicationName
								id
								}
							}
							}
						`);
					if (data.services) {
						setAllServices(data.services);
					}
					// console.log(CurrentApplicationId);
					// console.log("id");

					// console.log("All services",allServices
					// 	.filter((e:any) => (e.application.id) == CurrentApplicationId)
					// 	.filter((e:any) => e.status != 'rejected')
					// 	.map((e:any) => e.serviceName));

						setNameChange(false);

					setFilteredServices(allServices
						.filter((e:any) => (e.application.id) == CurrentApplicationId)
						.filter((e:any) => e.status != 'rejected')
						.map((e:any) => e.serviceName));

					if(filteredServices.includes(currentService))
						setNameChange(true);

						// console.log("Filtered Services check",filteredServices.includes(currentService));
						// console.log("Current Service->",currentService);

				} catch (error) {
					console.log("D",error);
				}
			})();
		}, [rerender]);

	React.useEffect(() => {
		(async () => {
			try {
				const data = await queryGraphql(
					`
                        query($serviceId: String!){
                        service(id:$serviceId) {
						id,
                        serviceName,
						gcpServiceViewers,
                        application{
                        id,
                        applicationName,
						cluster{
						id,
						clusterName,
						environment
						}
                        },
						serviceRequesters,
						framework,
						costLabelPairs{
						cost,
						label
						},
                        }
                        }
`,
					{ serviceId: id }
				);
				if (data.service) {
					setService(data.service);
				}
			} catch (error) {
				console.log("A",error);
			}
		})();
	}, []);
	React.useEffect(() => {
		(async () => {
			try {

				const data2 = await queryGraphql(`
					query Users {
							users {
								id,
								name,
								email,
								clustersViewable {
								clusterName,
								id,
								environment,
								}
								applicationsViewable {
								applicationName,
								id,
								environment,
								}
							}
							}
				`);
			// if(data2.users)	{
			// 	console.log("clsuter viewable", data2.users.filter((e:any) => e.email == user.email).map((e:any)=> e.clustersViewable).flat().map((e:any)=> e.id) );
			// }
			
				const data = await queryGraphql(
					`
                       query{
                        clusters {
						id,
                        clusterName,
                        environment,
						status,
                        applications{
                        id,
                        applicationName,
                        status,
                        environment
                        }
                        }
                        }
					`
				);
				if (data.clusters) {
					setApplications(data.clusters.map((e: any) => e.applications).flat(2));
					
					// console.log("B",applications);
					setApplicationsNamesList(
						Array.from(
							new Set(
								(data.clusters 
									.filter((cluster: any) => cluster.clusterName == currentCluster) 
									.map((cluster: any) => cluster.applications) 
									.flat(2) 
									?.filter((application: any) => application.status == "active") 
									.filter((application: any) => { 
										if (isViewer) {
											return true; 
										}										
										return data2.users
											?.filter((userRecord: any) => userRecord.email == user.email)
											.map((userRecordMap: any) => userRecordMap.applicationsViewable)
											.flat() 
											.map((viewableAppDescriptor: any) => viewableAppDescriptor.id)
											.includes(application.id);
									})
									.map((application: any) => application.applicationName) 
								) || [] 
							)
						)
					);
					setCurrentApplicationId(
						Array.from(
						new Set(
							data.clusters
								.filter((e:any) => e.clusterName == currentCluster)
								.map((e: any) => e.applications)
								.flat(2)
								?.filter((e: any) => e.status == "active" && e.applicationName == currentApplication && e.environment== 'dev')
								.map((e: any) => e.id)
						)
					));
					
					setClustersNamesList(
						Array.from(
							new Set(
								(data.clusters
									?.filter((e: any) => e.status == "active") 
									.filter((e: any) => { 
										if (isViewer) {
											return true; 
										}
										return data2.users
											?.filter((eUser: any) => eUser.email == user.email)
											.map((eUserMap: any) => eUserMap.clustersViewable)
											.flat()
											.map((eViewableCluster: any) => eViewableCluster.id)
											.includes(e.id);
									})
									.map((e: any) => e.clusterName) 
								) || [] 
							)
						)
					);
				}
			} catch (error) {
				console.log("C",error);
			}
		})();
	}, [currentCluster,currentApplication, rerender]);

	React.useEffect(() => {
		(async () => {
			try {
				const data = await queryGraphql(`
                        query Users {
								users {
									id,
									name,
									email,
									clustersViewable {
									clusterName,
									id,
									environment,
									}
									applicationsViewable {
									applicationName,
									id,
									environment,
									}
								}
								}
					`);
				if (data.users) {
					setUsers(data.users);
				}
			} catch (error) {
				console.log("D",error);
			}
		})();
	}, []);
	
	// console.log("userrr",users.filter((e:any) => e.email == user.email) );
	return (
		<Container
			disableGutters
			maxWidth={false}
			sx={{ padding: "24px", bgcolor: "#fafafa", minHeight: "100vh" }}
		>
				<MiniBot/>
			<Box sx={{ mb: 4 }}>
				<Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
					<Link underline="hover" color="inherit" href="/services">
						Services
					</Link>
					<Typography color="text.primary">
						{isEdit ? "Edit Service Details" : "Add New Service"}
					</Typography>
				</Breadcrumbs>
				<Box display="flex" alignItems="center" mt={2}>
					<IconButton
						edge="start"
						aria-label="back"
						color="inherit"
						onClick={() => navigate("/services")}
					>
						<ArrowBackIosNewIcon fontSize="small" />
					</IconButton>
					<Typography fontFamily="Gilroy-Bold" fontSize="18px">
						{isEdit ? "Edit Service Details" : "Add New Service"}
					</Typography>
				</Box>
			</Box>
			<Grid container>
				<Grid item xs={1}></Grid>
				<Grid item xs={10}>
					{((isEdit && service.id) || !isEdit) && (
						<Formik
							initialValues={{
								serviceName: isEdit ? service.serviceName : "",
								cluster: isEdit ? service?.application?.cluster?.clusterName : "",
								application: isEdit ? service?.application?.applicationName : "",
								framework: isEdit ? service.framework : "",
								gcpServiceViewers: isEdit ? service.gcpServiceViewers : [],
								serviceRequesters: isEdit ? service.serviceRequesters : [],
								costCenterValue: isEdit
									? service.costLabelPairs?.find((elem: any) => elem.cost == "cost-center")
											.label
									: "",
									costLabelPairs: isEdit
									? service?.costLabelPairs?.filter(
											(e: any) => !["department", "cost-center", "cluster-owner"].includes(e.cost)
									  )
									: [],
							}}
							validationSchema={validationSchema}
							onSubmit={async ({
								serviceName,
								cluster,
								application,
								framework,
								gcpServiceViewers,
								serviceRequesters,
								costLabelPairs,
								costCenterValue,
							}) => {
								// console.log({
								// 	serviceName,
								// 	cluster,
								// 	application,
								// 	framework,
								// 	gcpServiceViewers,
								// 	serviceRequesters,
								// });
								if (!isEdit) {

									let keyValuePairs = [];
									keyValuePairs.push({
										cost: "cost-center",
										label: costCenterValue,
									});
									keyValuePairs.push(
										...costLabelPairs.map((e: any) => {
											return { cost: e.cost, label: e.label };
										})
									);
								
									const data = await queryGraphql(
										`
					                            mutation CreateService($input: ServiceCreateInput) {
					  createService(input: $input) {
					    id
					  }
					}
					    `,
										{
											input: {
												serviceName,
												gcpServiceViewers,
												application: applications.filter(
													(e: any) => e.applicationName == application
												)[0]["id"],
												serviceRequesters,
												framework,
												costLabelPairs: keyValuePairs,
										
											},
										}
									);

									const info = await queryGraphql(`mutation Mutation($input: ResourceStatusCreateInput) {
										createResourceStatus(input: $input) {
											id
										}
										}`, {
											input: {
											  currentStatus: "pending",
											  resourceEnvironment: "dev",
											  resourceId: data.createService.id,
											  resourceName: serviceName,
											  resourceType: "service"
											}
										  });

									if (data.createService.id && info.createResourceStatus.id) {
										navigate("/services");
									}
									return;
								} else {
									let keyValuePairs = [];
									keyValuePairs.push({
										cost: "cost-center",
										label: costCenterValue,
									});
									keyValuePairs.push(
										...costLabelPairs.map((e: any) => {
											return { cost: e.cost, label: e.label };
										})
									);

									const data = await queryGraphql(
										`
					                           mutation UpdateService($input: ServiceUpdateInput) {
								updateService(input: $input) {
								  id
								}
							  }
					    `,
										{
											input: {
												id: id,
												serviceName,
												gcpServiceViewers,
												application: applications.filter(
													(e: any) => e.applicationName == application
												)[0]["id"],
												serviceRequesters,
												framework,
												costLabelPairs: keyValuePairs,
											},
										}
									);
									const info = await queryGraphql(`mutation Mutation($input: ResourceStatusUpdateInput) {
										updateResourceStatus(input: $input) {
											id
										}
										}`, {
											input: {
											  currentStatus: "pending",
											  resourceId: id,
											  resourceName: serviceName
											}
										  });

									if (data.updateService.id && info.updateResourceStatus.id) {
										navigate("/services");
									}
									return;
								}
							}}
						>
							{({
								handleChange,
								handleBlur,
								values,
								setFieldValue,
								errors,
								touched,
								isValid,
								dirty,
							}) => {
								// console.log("E",errors);
								return (
									<Form id="main-form"> 
										<Box>
											<Typography fontFamily="Gilroy-Medium" fontSize="16px" mb={4}>
												{isEdit
													? "Make changes to below details and save"
													: "Fill the below details to add service"}
											</Typography>
											<div
												style={{
													backgroundColor: "white",
													padding: "24px",
													borderRadius: "8px",
													boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
													marginBottom: "24px",
												}}
											>
												<Typography
													fontFamily="Gilroy-Medium"
													fontSize="14px"
													style={{ marginBottom: "16px" }}
												>
													Basic Information
												</Typography>
												<Divider sx={{ marginBottom: "24px" }} />
												<Grid container spacing={4} style={{ marginBottom: "16px" }}>
													<Grid item xs={12} sm={6}>
														<CompulsoryFieldsLabel fieldName="Service Name" />
														<TextField
															sx={{
																"& .MuiFilledInput-root": {
																	border:
																		errors["serviceName"] && touched["serviceName"]
																			? "1px solid red"
																			: "1px solid #00000000",

																	"&.Mui-focused": {
																		backgroundColor: "white",
																		border: "1px solid black",
																	},
																},
															}}
															variant="filled"
															fullWidth
															name="serviceName"
															value={values.serviceName}
															// onChange={handleChange}
															onChange={(e:any) =>{
																handleChange(e);
																setCurrentService(e.target.value);
															}}
															onBlur={handleBlur}
															placeholder="Enter name here"
															size="medium"
															hiddenLabel
															InputProps={{
																disableUnderline: true,

																style: {
																	borderRadius: "8px",
																},
															}}
														/>
														<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
															{/* <ErrorMessage name="serviceName" component="div" /> */}
															{errors.serviceName && touched.serviceName && (
																	<ErrorMessage name="serviceName" component="div" />
																	)}
																	{nameChange && (
																	<span>Service name exists</span>
																	)}
														</div>
													</Grid>
													<Grid item xs={12} sm={6}>
														<CompulsoryFieldsLabel fieldName="Cluster" />
														<Autocomplete
															options={clustersNamesList}
															// getOptionLabel={(option) => option || ""}
															filterSelectedOptions
															defaultValue={values.cluster}
															onChange={(e, newVal, reason) => {
																// setApplicationOwners(newVal);
																// console.log(newVal);
																
																	setFieldValue("cluster", newVal);
																	setCurrentCluster(newVal);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="filled"
																	fullWidth
																	placeholder="Select"
																	size="medium"
																	hiddenLabel
																	sx={{
																		"& .MuiFilledInput-root": {
																			border:
																				errors["cluster"] && touched["cluster"]
																					? "1px solid red"
																					: "1px solid #00000000",
																			"&.Mui-focused": {
																				backgroundColor: "white",
																				border: "1px solid black",
																			},
																		},
																	}}
																	InputProps={{
																		...params.InputProps,
																		style: {
																			borderRadius: "8px",
																		},

																		disableUnderline: true,
																	}}
																/>
															)}
														/>

														<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
															{getIn(errors, `cluster`)}
														</div>
													</Grid>
													<Grid item xs={12} sm={6}>
														<CompulsoryFieldsLabel fieldName="Application" />
														<Autocomplete
															options={applicationsNamesList}
															// getOptionLabel={(option) => option || ""}
															filterSelectedOptions
															defaultValue={values.application}
															onChange={(e, newVal, reason) => {
																// setApplicationOwners(newVal);
																// console.log(newVal);
																
																	setFieldValue("application", newVal);
																	// setFieldValue("environment", newVal.environment);
																	setCurrentApplication(newVal);
																
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="filled"
																	fullWidth
																	placeholder="Select"
																	size="medium"
																	hiddenLabel
																	sx={{
																		"& .MuiFilledInput-root": {
																			border:
																				errors["application"] && touched["application"]
																					? "1px solid red"
																					: "1px solid #00000000",
																			"&.Mui-focused": {
																				backgroundColor: "white",
																				border: "1px solid black",
																			},
																		},
																	}}
																	InputProps={{
																		...params.InputProps,
																		style: {
																			borderRadius: "8px",
																		},

																		disableUnderline: true,
																	}}
																/>
															)}
														/>

														<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
															{getIn(errors, `application`)}
														</div>
													</Grid>
													<Grid item xs={12} sm={6}>
														<CompulsoryFieldsLabel fieldName="Framework" />
														<Autocomplete
															options={frameworkList}
															filterSelectedOptions
															defaultValue={values.framework}
															onChange={(e, newVal, reason) => {
																// setApplicationOwners(newVal);

																setFieldValue("framework", newVal);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="filled"
																	fullWidth
																	placeholder="Select"
																	size="medium"
																	hiddenLabel
																	sx={{
																		"& .MuiFilledInput-root": {
																			border:
																				errors["framework"] && touched["framework"]
																					? "1px solid red"
																					: "1px solid #00000000",
																			"&.Mui-focused": {
																				backgroundColor: "white",
																				border: "1px solid black",
																			},
																		},
																	}}
																	InputProps={{
																		...params.InputProps,
																		style: {
																			borderRadius: "8px",
																		},

																		disableUnderline: true,
																	}}
																/>
															)}
														/>

														<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
															{getIn(errors, `framework`)}
														</div>
													</Grid>
												</Grid>
											</div>
											<div
												style={{
													backgroundColor: "white",
													padding: "24px",
													borderRadius: "8px",
													boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
													marginBottom: "24px",
												}}
											>
												<Typography
													fontFamily="Gilroy-Medium"
													fontSize="14px"
													style={{ marginBottom: "16px" }}
												>
													Service Viewers and Service Owners
												</Typography>
												<Divider sx={{ marginBottom: "24px" }} />
												<Grid container spacing={4} style={{ marginBottom: "16px" }}>
													<Grid item xs={12} sm={6}>
														<CompulsoryFieldsLabel fieldName="Service Viewers" />
														<Autocomplete
															multiple
															// options={[].map((e: any) => e.email)}
															options={users.map((e: any) => e.email)}
															filterSelectedOptions
															ChipProps={{ size: "small" }}
															freeSolo
															defaultValue={values.gcpServiceViewers}
															onChange={(e, newVal, reason) => {
																// setApplicationOwners(newVal);
																setFieldValue("gcpServiceViewers", newVal);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="filled"
																	fullWidth
																	placeholder="e.g. abc121@gmail.com"
																	size="small"
																	hiddenLabel
																	InputProps={{
																		...params.InputProps,
																		style: {
																			borderRadius: "8px",
																		},
																		disableUnderline: true,
																	}}
																/>
															)}
														/>
														<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
															{typeof getIn(errors, `gcpServiceViewers`) == "string"
																? getIn(errors, `gcpServiceViewers`)
																: (getIn(errors, `gcpServiceViewers`) as string[])?.filter(
																		(e) => e != null
																  )[0]}
														</div>
													</Grid>
													<Grid item xs={12} sm={6}>
														<CompulsoryFieldsLabel fieldName="Service Owners" />
														<Autocomplete
															multiple
															options={users.map((e: any) => e.email)}
															// options={[].map((e: any) => e.email)}
															filterSelectedOptions
															ChipProps={{ size: "small" }}
															freeSolo
															defaultValue={values.serviceRequesters}
															onChange={(e, newVal, reason) => {
																// setApplicationOwners(newVal);

																setFieldValue("serviceRequesters", newVal);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="filled"
																	fullWidth
																	placeholder="e.g. abc121@gmail.com"
																	size="small"
																	hiddenLabel
																	InputProps={{
																		...params.InputProps,
																		style: {
																			borderRadius: "8px",
																		},

																		disableUnderline: true,
																	}}
																/>
															)}
														/>
														<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
															{typeof getIn(errors, `serviceRequesters`) == "string"
																? getIn(errors, `serviceRequesters`)
																: (getIn(errors, `serviceRequesters`) as string[])?.filter(
																		(e) => e != null
																  )[0]}
														</div>
													</Grid>
												</Grid>
											</div>

											<div
																							style={{
																								backgroundColor: "white",
																								padding: "24px",
																								borderRadius: "8px",
																								boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
																								marginBottom: "24px",
																							}}
																						>
																							<Typography
																								fontFamily="Gilroy-Medium"
																								fontSize="14px"
																								style={{ marginBottom: "16px" }}
																							>
																								Service Tags / Labels
																							</Typography>
																							<Divider sx={{ marginBottom: "24px" }} />
																							<Grid container spacing={4} style={{ marginBottom: "16px" }}>
																								<Grid item xs={12} sm={6}>
																									<Typography
																										gutterBottom
																										fontFamily="Gilroy-Regular"
																										fontSize="14px"
																										ml="4px"
																									>
																										Key
																									</Typography>
																								</Grid>
																								<Grid item xs={12} sm={6}>
																									<Typography
																										gutterBottom
																										fontFamily="Gilroy-Regular"
																										fontSize="14px"
																										ml="4px"
																									>
																										Value
																									</Typography>
																								</Grid>
																							</Grid>
																							<Grid container spacing={4}>
																								<Grid item xs={12} sm={6}>
																									<TextField
																										fullWidth
																										placeholder="Enter key"
																										size="medium"
																										hiddenLabel
																										disabled={true}
																										value="cost-center"
																										variant="filled"
																										sx={{ marginBottom: "0px" }}
																										InputProps={{
																											disableUnderline: true,
																											style: {
																												borderRadius: "8px",
																											},
																										}}
																									/>
																								</Grid>
																								<Grid item xs={12} sm={6}>
																									<Box display="flex" alignItems="center" justifyContent="space-between">
																										<TextField
																											fullWidth
																											placeholder="Enter value"
																											size="medium"
																											value={values.costCenterValue}
																											hiddenLabel
																											variant="filled"
																											name="costCenterValue"
																											sx={{
																												"& .MuiFilledInput-root": {
																													border:
																														errors["costCenterValue"] && touched["costCenterValue"]
																															? "1px solid red"
																															: "1px solid #00000000",
																													"&.Mui-focused": {
																														backgroundColor: "white",
																														border: "1px solid black",
																													},
																												},
																												marginBottom: "0px",
																											}}
																											onChange={handleChange}
																											onBlur={handleBlur}
																											InputProps={{
																												disableUnderline: true,
																												style: {
																													borderRadius: "8px",
																												},
																											}}
																										/>
																									</Box>
																									<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
																										<ErrorMessage name="costCenterValue" component="div" />
																									</div>
																								</Grid>
																							</Grid>
																							<Grid container spacing={4} mt="8px">
																								{values.costLabelPairs?.map((e: any, index: number) => (
																									<>
																										<Grid item xs={12} sm={6} key={index}>
																											<TextField
																												fullWidth
																												placeholder="Enter key"
																												size="medium"
																												hiddenLabel
																												value={e.cost}
																												sx={{
																													"& .MuiFilledInput-root": {
																														border: "1px solid #00000000",
																														"&.Mui-focused": {
																															backgroundColor: "white",
																															border: "1px solid black",
																														},
																													},
																													marginBottom: "0px",
																												}}
																												variant="filled"
																												onChange={(event) => {
																													setFieldValue("costLabelPairs", [
																														...values.costLabelPairs.map((pair: any) => {
																															if (e.id === pair.id) {
																																pair.cost = event.target.value || "";
																															}
																															return pair;
																														}),
																													]);
																												}}
																												InputProps={{
																													disableUnderline: true,
																													style: {
																														borderRadius: "8px",
																													},
																												}}
																											/>
																											<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
																												{getIn(errors, `costLabelPairs[${index}].cost`)}
																											</div>
																										</Grid>
																										<Grid item xs={12} sm={6}>
																											<Box
																												display="flex"
																												alignItems="center"
																												justifyContent="space-between"
																											>
																												<TextField
																													fullWidth
																													placeholder="Enter value"
																													size="medium"
																													sx={{
																														"& .MuiFilledInput-root": {
																															border: "1px solid #00000000",
																															"&.Mui-focused": {
																																backgroundColor: "white",
																																border: "1px solid black",
																															},
																														},
																														marginBottom: "0px",
																													}}
																													value={e.label}
																													hiddenLabel
																													variant="filled"
																													onChange={(event) => {
																														setFieldValue("costLabelPairs", [
																															...values.costLabelPairs.map((pair: any) => {
																																if (e.id === pair.id) {
																																	pair.label = event.target.value || "";
																																}
																																return pair;
																															}),
																														]);
																													}}
																													InputProps={{
																														disableUnderline: true,
																														style: {
																															borderRadius: "8px",
																														},
																													}}
																												/>
											
																												<Button
																													sx={{ marginLeft: "8px" }}
																													onClick={() => {
																														let clpArr = values.costLabelPairs.filter((pair: any) => {
																															return pair.id != e.id;
																														});
											
																														setFieldValue("costLabelPairs", clpArr);
																													}}
																												>
																													<img alt="close-icon" src="/assets/close-icon.svg" />
																												</Button>
																											</Box>
																											<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
																												{getIn(errors, `costLabelPairs[${index}].label`)}
																											</div>
																										</Grid>
																									</>
																								))}
																							</Grid>
																							<Button
																								variant="text"
																								sx={{ color: "#000000", textTransform: "none", mt: "16px" }}
																								onClick={() =>
																									setFieldValue("costLabelPairs", [
																										...values.costLabelPairs,
																										{ cost: "", label: "", id: crypto.randomUUID() },
																									])
																								}
																							>
																								+ Add Key Value Pair
																							</Button>
																						</div>

										</Box>
										<Box display="flex" justifyContent="flex-end" gap={2}>
											<Button
												sx={{
													color: "black",
													borderColor: "black",
													fontWeight: "bold",
													textTransform: "none",
													px: 4,
												}}
												variant="outlined"
												size="large"
												onClick={() => navigate("/services")}
											>
												Cancel
											</Button>
											<Button
												sx={{
													backgroundColor: "black",
													color: "white",
													fontWeight: "bold",
													"&:hover": {
														backgroundColor: "white",
														color: "black",
														borderColor: "black",
													},
													textTransform: "none",
													px: 4,
												}}
												variant="contained"
												size="large"
												type="submit"
												disabled={!(isValid && dirty && !nameChange) || isViewer}
												// onClick={handleOpenModal}
											>
												{isEdit ? "Save Changes" : "Add New Service"}
											</Button>
											
										</Box>
									</Form>
								);
							}}
						</Formik>
					)}
				</Grid>
				<Grid item xs={1}></Grid>
			</Grid>
		</Container>
	);
};

//export default ServiceRequesterForm;
const ServiceRequesterForm: React.FC<ServiceFormProps> = ({ isEdit }) => {
    const theme = useTheme();

    const getInitialDrawerState = () => {
        if (typeof window !== 'undefined') {
            const storedState = localStorage.getItem('isFaradayDrawerOpen');
            return storedState !== null ? JSON.parse(storedState) : true;
        }
        return true;
    };
    const [isDrawerActuallyOpen, setIsDrawerActuallyOpen] = useState<boolean>(getInitialDrawerState);

    const handleDrawerStateChange = (isOpenFromDrawer: boolean) => {
        setIsDrawerActuallyOpen(isOpenFromDrawer);
    };

    // Using your remembered calculation for marginLeft
    const currentMarginLeft = isDrawerActuallyOpen ? openDrawerWidth - 248 : collapsedDrawerWidth - 70;
	const copyIsEdit = isEdit;
    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <MainDrawer
                // Assuming "integrations" is the correct index for Kyverno page
                // If Kyverno has its own top-level menu item, update this index.
                index={"services"} // Or a more specific index like "integrations-kyverno" if applicable
                onStateChange={handleDrawerStateChange}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    // bgcolor: '#fafafa', // bgcolor commented out as per your previous change
                    p: 0,
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    // Using your remembered unit and calculation for marginLeft
                    marginLeft: `${currentMarginLeft}vh`,
                }}
            >
                <ServiceRequesterFormContent isEdit={copyIsEdit} />
            </Box>
        </Box>
    );
};

export default ServiceRequesterForm;